
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import DecorationTrunk from "../../decorations/jungle/DecorationTrunk";
import PlatformMarkerFoliage3 from "../../editor/platform-markers/jungle/PlatformMarkerFoliage3";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import MegaGemMarker from "../../editor/entity-markers/MegaGemMarker";
import SmashableMarkerVine from "../../editor/entity-markers/SmashableMarkerVine";
import SimpleBreakableBlocker from "../../../components/platformer/SimpleBreakableBlocker";
import PlatformMarkerFoliage4 from "../../editor/platform-markers/jungle/PlatformMarkerFoliage4";
import PlatformFoliage1 from "../../platforms/jungle/PlatformFoliage1";
import PlatformFoliage2 from "../../platforms/jungle/PlatformFoliage2";
import CheckpointMarker from "../../editor/CheckpointMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class JungleChunkEasy2 extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 341, y ?? 108);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 4941, 661);
    this.add(editor_bounds_right);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, -331, 661);
    this.add(editor_bounds_left);

    // trunk_png_1
    const trunk_png_1 = new DecorationTrunk(scene, 2278, 807);
    this.add(trunk_png_1);

    // trunk_png_2
    const trunk_png_2 = new DecorationTrunk(scene, -86, 806);
    this.add(trunk_png_2);

    // trunk_png
    const trunk_png = new DecorationTrunk(scene, 546, 584);
    this.add(trunk_png);

    // platformMarkerFoliage_1
    const platformMarkerFoliage_1 = new PlatformMarkerFoliage3(scene, 2275, 503);
    this.add(platformMarkerFoliage_1);

    // platformMarkerFoliage_2
    const platformMarkerFoliage_2 = new PlatformMarkerFoliage3(scene, 4435, 415);
    this.add(platformMarkerFoliage_2);

    // gemMarker_11
    const gemMarker_11 = new SmallGemMarker(scene, 815, 310);
    this.add(gemMarker_11);

    // megaGemMarker_2
    const megaGemMarker_2 = new MegaGemMarker(scene, 1103, 362);
    this.add(megaGemMarker_2);

    // smashableMarkerVine
    const smashableMarkerVine = new SmashableMarkerVine(scene, 1008, 244);
    this.add(smashableMarkerVine);

    // platformMarkerFoliage4
    const platformMarkerFoliage4 = new PlatformMarkerFoliage4(scene, 923, 450);
    this.add(platformMarkerFoliage4);

    // platformFoliage1
    const platformFoliage1 = new PlatformFoliage1(scene, 1024, 96);
    this.add(platformFoliage1);

    // platformFoliage2
    const platformFoliage2 = new PlatformFoliage2(scene, 550, 280);
    this.add(platformFoliage2);

    // platformFoliage
    const platformFoliage = new PlatformFoliage1(scene, 1595, 34);
    this.add(platformFoliage);

    // trunk_png_4
    const trunk_png_4 = new DecorationTrunk(scene, 927, 759);
    this.add(trunk_png_4);

    // trunk_png_5
    const trunk_png_5 = new DecorationTrunk(scene, 4423, 718);
    this.add(trunk_png_5);

    // trunk_png_7
    const trunk_png_7 = new DecorationTrunk(scene, 1604, 886);
    this.add(trunk_png_7);

    // platformMarkerFoliage_3
    const platformMarkerFoliage_3 = new PlatformMarkerFoliage4(scene, 1620, 578);
    this.add(platformMarkerFoliage_3);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 1606, -67);
    this.add(gemMarker);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 4427, 313);
    this.add(gemMarker_1);

    // gemMarker_2
    const gemMarker_2 = new SmallGemMarker(scene, 2138, 14);
    this.add(gemMarker_2);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, 1021, 13);
    this.add(gemMarker_3);

    // gemMarker_4
    const gemMarker_4 = new SmallGemMarker(scene, 536, 152);
    this.add(gemMarker_4);

    // gemMarker_5
    const gemMarker_5 = new SmallGemMarker(scene, 2306, -10);
    this.add(gemMarker_5);

    // gemMarker_6
    const gemMarker_6 = new SmallGemMarker(scene, 1621, 449);
    this.add(gemMarker_6);

    // megaGemMarker
    const megaGemMarker = new MegaGemMarker(scene, 2374, 424);
    this.add(megaGemMarker);

    // platformMarkerFoliage_5
    const platformMarkerFoliage_5 = new PlatformMarkerFoliage3(scene, 3744, 337);
    this.add(platformMarkerFoliage_5);

    // trunk_png_8
    const trunk_png_8 = new DecorationTrunk(scene, 3732, 641);
    this.add(trunk_png_8);

    // gemMarker_7
    const gemMarker_7 = new SmallGemMarker(scene, 3736, 235);
    this.add(gemMarker_7);

    // platformMarkerFoliage_6
    const platformMarkerFoliage_6 = new PlatformMarkerFoliage4(scene, -68, 496);
    this.add(platformMarkerFoliage_6);

    // smashableMarkerVine_1
    const smashableMarkerVine_1 = new SmashableMarkerVine(scene, 2293, 295);
    this.add(smashableMarkerVine_1);

    // platformMarkerFoliage
    const platformMarkerFoliage = new PlatformMarkerFoliage4(scene, 2282, 130);
    this.add(platformMarkerFoliage);

    // gemMarker_8
    const gemMarker_8 = new SmallGemMarker(scene, 2449, 11);
    this.add(gemMarker_8);

    // megaGemMarker_1
    const megaGemMarker_1 = new MegaGemMarker(scene, 3155, 364);
    this.add(megaGemMarker_1);

    // smashableMarkerVine_2
    const smashableMarkerVine_2 = new SmashableMarkerVine(scene, 3060, 246);
    this.add(smashableMarkerVine_2);

    // platformMarkerFoliage_7
    const platformMarkerFoliage_7 = new PlatformMarkerFoliage4(scene, 2975, 452);
    this.add(platformMarkerFoliage_7);

    // trunk_png_9
    const trunk_png_9 = new DecorationTrunk(scene, 2979, 761);
    this.add(trunk_png_9);

    // gemMarker_9
    const gemMarker_9 = new SmallGemMarker(scene, 3073, 15);
    this.add(gemMarker_9);

    // platformMarkerFoliage_8
    const platformMarkerFoliage_8 = new PlatformMarkerFoliage3(scene, 3034, 96);
    this.add(platformMarkerFoliage_8);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, -225, 431);
    this.add(checkpointMarker);

    // checkpointMarker_1
    const checkpointMarker_1 = new CheckpointMarker(scene, 1455, 503);
    this.add(checkpointMarker_1);

    // checkpointMarker_2
    const checkpointMarker_2 = new CheckpointMarker(scene, 3626, 294);
    this.add(checkpointMarker_2);

    // this (components)
    new ChunkBoundaries(this);

    // smashableMarkerVine (components)
    const smashableMarkerVineSimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerVine);
    smashableMarkerVineSimpleBreakableBlocker.allowedCharacter = "panda";

    // smashableMarkerVine_1 (components)
    const smashableMarkerVine_1SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerVine_1);
    smashableMarkerVine_1SimpleBreakableBlocker.allowedCharacter = "ice";

    // smashableMarkerVine_2 (components)
    const smashableMarkerVine_2SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerVine_2);
    smashableMarkerVine_2SimpleBreakableBlocker.allowedCharacter = "grizz";
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
